<template>
    <div class="collapsible-option" :class="optionCssClasses">
        <div class="header" :class="headerCssClasses" @click="select">
            <div class="icon" @click.stop="toggle"></div>
            <div class="title">
                <template v-if="selectable">
                    <checkbox tag-name="div"
                              :checked="checked"
                              :indeterminate="indeterminate"
                              :disabled="value.disabled">
                        <slot :item="value.item"
                              :title="value.title"
                              :disabled="value.disabled"
                        >{{ value.title }}
                        </slot>
                    </checkbox>
                </template>
                <template v-else>
                    <slot :item="value.item"
                          :title="value.title"
                          :disabled="value.disabled"
                    >{{ value.title }}
                    </slot>
                </template>
            </div>
        </div>
        <div class="nested">
            <Node v-for="it in value.nested"
                  v-show="it.visible"
                  :key="it.key" :value="it"
                  :level="level + 1"
                  :selectedMap="selectedMap"
                  :flat-groups="flatGroups"
                  :select-all-nested="selectAllNested"
                  :selectable-groups="selectableGroups"
                  @selected="$emit('selected', $event)">
                <template #default="{item, title, disabled}">
                    <slot :item="item"
                          :title="title"
                          :disabled="disabled"
                    >{{ title }}
                    </slot>
                </template>
            </Node>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Node',
    props: {
        value: {
            type: Object,
            required: true
        },
        selectedMap: {
            type: Object,
            required: true
        },
        selectableGroups: {
            type: Boolean,
            default: false
        },
        selectAllNested: {
            type: Boolean,
            default: false,
        },
        flatGroups: {
            type: Boolean,
            default: false
        },
        level: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            collapsed: true
        };
    },
    computed: {
        optionCssClasses() {
            return {
                flat     : this.flatGroups,
                hasnested: this.hasNested,
                collapsed: this.collapsed,
                ['level-' + this.level]: true
            };
        },
        headerCssClasses() {
            return {
                disabled: this.value.disabled,
            };
        },
        hasNested() {
            if (!this.value.nested)
                return false;

            return this.value.nested.length > 0;
        },
        selectedCount() {
            let count = 0;
            for (const it of this.value.nested) {
                if (this.selectedMap[it.key])
                    count++;
            }
            return count;
        },
        checked() {
            if (this.hasNested && this.selectAllNested && !this.selectableGroups)
                return this.selectedCount === this.value.nested.length;

            return !!this.selectedMap[this.value.key];
        },
        indeterminate() {
            if (this.hasNested && this.selectAllNested && !this.selectableGroups)
                return this.selectedCount > 0 && this.selectedCount < this.value.nested.length;

            return false;
        },
        selectable() {
            return !this.hasNested || this.selectableGroups || this.selectAllNested;
        },
    },
    methods: {
        toggle() {
            this.collapsed = !this.collapsed;
        },
        select() {
            if (this.selectable) {
                this.$emit('selected', this.value);
            } else {
                this.toggle();
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import './node.scss';
</style>
